import React from 'react'
import tw from 'twin.macro'
import styled from 'styled-components'
import { css } from 'styled-components/macro' //eslint-disable-line

const Container = tw.div`relative pt-12 md:pt-12 lg:pt-24 pb-12 lg:pb-20`

const OpacityOverlay = tw.div`z-10 absolute inset-0`

const HeroContainer = tw.div`z-20 relative px-6 sm:px-8 mx-auto h-full flex flex-col`
const Content = tw.div`px-4 flex flex-1 flex-col justify-center items-center`

const Heading = styled.h1`
  ${tw`text-3xl text-center sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-100 leading-snug -mt-4 sm:mt-0`}
  span {
    ${tw`inline-block mt-2`}
  }
`

export const Hero = ({ heading, bgColor }) => {
  return (
    <>
      <Container>
        <OpacityOverlay className={bgColor} />
        <HeroContainer>
          <Content>
            <Heading>{heading}</Heading>
          </Content>
        </HeroContainer>
      </Container>
      <div className="mr-for-radius">
        <svg
          className="hidden xl:block h-6  md:h-10 lg:h-14 w-full text-green-500"
          viewBox="0 0 10 10"
          preserveAspectRatio="none"
        >
          <polygon fill="currentColor" points="0 0 10 0 0 10"></polygon>
        </svg>
      </div>
    </>
  )
}
